import Vuex from "vuex";
import Vue from "vue";
import { queryAccountInfo } from "../service/getData";
import { baiduReport } from "../js/common";
import { businessNo } from "../config/env";

Vue.use(Vuex);

console.log("Vuex");

export const store = new Vuex.Store({
  state: {
    userInfo: JSON.parse(localStorage.getItem("userInfo")) || {}, // 用户信息
    selectedGame: [], // 选中的游戏信息
    weipayBusinessNo: "", // 公用微信支付的渠道号
    userData: {},
    businessNo: businessNo,
    encrypt: {},
  },
  actions: {
    getUserData({ commit }) {
      return queryAccountInfo()
        .then((res) => {
          if (res.data.code == 1) {
            commit("setUserData", res.data.result);
            return Promise.resolve();
          }
          return Promise.reject(res.data);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
  },
  mutations: {
    setUserData(state, data) {
      state.userData = data;
    },
    setUserInfo(state, data) {
      state.userInfo = data;
      if (!!data.newUser) {
        // 注册用户则上报百度
        baiduReport({
          newType: 3,
          mobile: data.mobile,
        });
      }
      localStorage.setItem("userInfo", JSON.stringify(data));
    },
    setUserEncrypt(state, data) {
      state.encrypt = data;
      localStorage.setItem("encrypt", JSON.stringify(data));
    },
    setSelectedGame(state, data) {
      state.selectedGame = data;
      localStorage.setItem("selectedGame", JSON.stringify(data));
    },
    setWeipayBusinessNo(state, data) {
      state.weipayBusinessNo = data;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js